<template>
  <main class="narrow-view">
    <h1>{{ $t('general.farewell') }}</h1>

    <div>{{ $t('general.logout-confirmation') }}</div>
    <div>{{ $t('general.next-action-question') }}</div>

    <FormButtonGroup>
      <RouterLinkButton :to="{ path: '/login' }">
        {{ $t('general.login-again') }}
      </RouterLinkButton>

      <FormButton @click="navigateToHomepage">
        {{ $t('general.to-homepage') }}
      </FormButton>
    </FormButtonGroup>
  </main>
</template>

<script lang="ts" setup>
import { onBeforeMount } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import { useAuthStore } from '@/store/bowler-app/auth'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { useUserStore } from '@/store/bowler-app/user'

const homepageUrl: string =
  process.env.VUE_APP_HOMEPAGE_URL ?? 'https://keilailu.fi/'

const navigateToHomepage = (): string => (window.location.href = homepageUrl)

onBeforeMount((): void => {
  useBowlerStore().clear()
  useUserStore().clear()
  useAuthStore().logout()
})
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;
}
</style>
